module.exports = __webpack_public_path__ + "img/tr.11c370c2.png";